import RadioCardListPage from "@components/RadioCardListPage"

const OPTIONS = [
  { emoji: "📌", key: "pinterest" },
  { emoji: "📱", key: "socialMedia" },
  { emoji: "🧠", key: "inMyHead" },
  { emoji: "🤷", key: "wingIt" },
]

export default function HomeCurrentSetupPage() {
  return (
    <RadioCardListPage translationKey="homeCurrentSetup" options={OPTIONS} />
  )
}
